import { RecipientType } from "@avenueops/shared-types";
import { InputOption, OptionGroup, SmartForm } from "@avenueops/web-components";
import { WorkflowPriority, WorkflowRecipientNotificationType } from "@prisma/client";
import _ from "lodash";
import React from "react";
import { useFormContext } from "react-hook-form";
import Skeleton from "react-loading-skeleton";
import { trpc2 } from "utils/trpc";

interface Props {
  notificationPrefix: any;
  priority?: WorkflowPriority;
}

/**
 * A wrapper for the InputDropdown specifically for notification contacts
 */
export default function ContactAutocomplete({ notificationPrefix, priority }: Props): JSX.Element {
  const { watch, formState, setValue } = useFormContext();

  const recipientType = watch(`${notificationPrefix}.recipientType`);

  const { isLoading, data: contactGroups } = trpc2.v2.workflows.contacts.list.useQuery();
  const recipientToType = new Map<string, RecipientType>(
    contactGroups?.flatMap((contactGroup) => contactGroup.contacts.map((contact) => [contact.contact.recipientId, contact.contact.recipientType])),
  );
  const optionGroups: OptionGroup[] | undefined = contactGroups?.map((contactGroup) => ({
    label: contactGroup.name,
    options: contactGroup.contacts.map((contact) => ({
      label: `${contact.name}`,
      description: contact.description,
      value: contact.contact.recipientId,
      meta: {
        recipientType: contact.contact.recipientType,
      },
    })),
  }));

  return (
    <div className="w-full flex flex-row gap-4">
      {isLoading || !optionGroups ? (
        <Skeleton />
      ) : (
        <>
          <SmartForm.DropdownSelect
            name={`${notificationPrefix}.recipientId`}
            options={optionGroups}
            title="Contact"
            onChangeCallback={(value) => {
              setValue(`${notificationPrefix}.recipientType`, recipientToType.get(value!));
            }}
            placeholder="Choose a contact ..."
          />
          {recipientType === "USER" ? (
            <SmartForm.DropdownSelect
              name={`${notificationPrefix}.recipientNotificationType`}
              options={Object.values(WorkflowRecipientNotificationType).map((notificationType) => {
                return { label: _.capitalize(notificationType), value: notificationType };
              })}
              title="Notification Type"
              placeholder="Choose a notification type..."
            />
          ) : null}
        </>
      )}
    </div>
  );
}
